import i18n from '../i18n';

export const getFieldSelectionOptions = () => [
  {
    title: i18n.t('returnHistory.fieldSelectionOptionsTitle.returnno'),
    value: 'RETURN_ORDER_NUMBER',
  },
  {
    title: i18n.t('returnHistory.fieldSelectionOptionsTitle.referenceNbr'),
    value: 'REFERENCE_NUMBER',
  },
  {
    title: i18n.t('returnHistory.fieldSelectionOptionsTitle.repNbr'),
    value: 'REPLACE_ORDER_NUMBER',
  },
  {
    title: i18n.t('returnHistory.fieldSelectionOptionsTitle.purchaseOrderNbr'),
    value: 'CUST_PO_NUMBER',
  },
  {
    title: i18n.t('returnHistory.fieldSelectionOptionsTitle.invoiceNbr'),
    value: 'INVOICE_NUMBER',
  },
  {
    title: i18n.t('returnHistory.fieldSelectionOptionsTitle.serialNbr'),
    value: 'SERIAL_NUMBER',
  },
  {
    title: i18n.t('returnHistory.fieldSelectionOptionsTitle.itemNbr'),
    value: 'ITEM_NUMBER',
  },
  {
    title: i18n.t('returnHistory.fieldSelectionOptionsTitle.serviceReturn'),
    value: 'SERVICE_REQUEST_NUMBER',
  },
];


export const getOrderFieldSelectionOptions = () => [
  {
    title: i18n.t('orderHistory.fieldSelectionOptionsTitle.invoiceNbr'),
    value: 'INVOICE_NUMBER',
  },
  {
    title: i18n.t('orderHistory.fieldSelectionOptionsTitle.purchaseOrderNbr'),
    value: 'CUST_PO_NUMBER',
  },
  {
    title: i18n.t('orderHistory.fieldSelectionOptionsTitle.orderNbr'),
    value: 'ORDER_NUMBER',
  },
  {
    title: i18n.t('orderHistory.fieldSelectionOptionsTitle.itemNbr'),
    value: 'ITEM_NUMBER',
  },
  {
    title: i18n.t('orderHistory.fieldSelectionOptionsTitle.referenceNbr'),
    value: 'REFERENCE_NUMBER',
  },
];


export const ORDER_TYPE = [
  {
    title: i18n.t('orderHistory.orderType.standardHME'),
    value: 'standard-hme',
  },
  {
    title: i18n.t('orderHistory.orderType.dropShip'),
    value: 'drop-ship',
  },
];

export const getMgOrderFieldSelectionOptions = () => [
  {
    title: i18n.t('maskGuaranteeHistory.fieldSelectionOptionsTitle.purchaseOrderNbr'),
    value: 'CUST_PO_NUMBER',
  },
  {
    title: i18n.t('maskGuaranteeHistory.fieldSelectionOptionsTitle.orderNbr'),
    value: 'ORDER_NUMBER',
  },
  {
    title: i18n.t('maskGuaranteeHistory.fieldSelectionOptionsTitle.referenceNbr'),
    value: 'REFERENCE_NUMBER',
  },
];

export const orderConfirmationData = {
  self: {
    type: 'orderconfirmationdetails.order-confirmation-details',
    uri: '/orderconfirmationdetails/resmed_us/giydamrwgy=',
    href: 'https://dev.commercehub-np.rmd.ros2-dev.dht.live/cortex/orderconfirmationdetails/resmed_us/giydamrwgy=',
  },
  messages: [],
  links: [],
  'account-name': 'A MEDICAL COMPANY- TEST ROS1',
  'account-number': '520040',
  'contact-name': 'Bhupesh Gupta',
  currency: 'USD',
  email: 'situeyunfynnu520040new@getnada.com',
  fax: ' ',
  'order-confirmation-attention-messages': {
    'attention-message': 'In response to COVID-19, if the damaged product does not show an RMA Number on this Order Confirmation, then return of the damaged product is not required. Please follow local guidelines for disposal.',
    questions: 'Please contact ResMed Customer Care at onlinestoresupport@resmed.com or call (800) 424-0737.',
  },
  'order-confirmation-item-details': [
    {
      item: '37208',
      'item-description': 'AirSense™ 10 AutoSet™ with HumidAir™ and ClimateLineAir™',
      'line-number': 0,
      po: '',
      'replacement-sales-order': null,
      rma: '2715564',
      'serial-number': '23171371242',
    },
  ],
  'order-date': '06/10/2024',
  'order-status': 'IN_PROGRESS',
  'order-type': 'RETURNS',
  'phone-number': '(111) 111-1111',
  'ref-number': '200266',
  'return-label-url': null,
  'ship-to-address': '9001 SPECTRUM CENTER BLVD, TEST, SAN DIEGO, CA, US, 92123',
};

export const placeOrderConfirmationData = {
  self: {
      type: 'orderconfirmationdetails.order-confirmation-details',
      uri: '/orderconfirmationdetails/resmed_us/geytcnjzgu=',
      href: 'http://localhost:9080/cortex/orderconfirmationdetails/resmed_us/geytcnjzgu=',
  },
  messages: [],
  links: [],
  'account-name': 'A MEDICAL COMPANY- TEST ROS1',
  'bill-to-address': '9001 SPECTRUM CENTER BLVD, TEST, SAN DIEGO, CA, US, 92123',
  currency: 'USD',
  'order-confirmation-attention-messages': {
      'footer-content': 'OnlineStore.ResMed.com',
      'footnotes-label': 'ResMed.com/ComplianceCoach-PAP-compliance',
      'general-terms': 'ResMed’s General Terms and Conditions of Sales apply. Visit ResMed.com/SalesTerms for more information.',
      'resmed-additional-footnotes-url': 'http://resmed.com/ComplianceCoach-PAP-compliance',
      'resmed-sales-url': 'http://resmed.com/SalesTerms/',
      'resmed-store-url': 'http://onlinestore.resmed.com/',
      'shipment-text': 'Shipping Expectations: Please allow a minimum of 2 weeks for in-stock orders that are shipping by ground and a minimum of 4 weeks for out-of-stock orders. Expedited in-stock orders will be processed on the same business day if received by 3 pm EST. Please expect email updates when items ship.',
      'subscription-agreement': 'Subscription Agreements : ',
      'thank-you-text': 'Thanks for your order! Did you know that in the ResMed Online Store you can place orders, track your order status 24/7 and get automatic shipment notifications without having to call customer service? Sign up and explore ROS today at ',
  },
  'order-confirmation-item-details': [
      {
          item: '64100',
          'item-description': 'AirFit™ F30 Complete Mask - Small',
          'line-number': 1,
          'line-price': 158.00,
          'line-tax': 0.00,
          'price-per-unit': 158.00,
          quantity: 1,
      },
      {
          item: null,
          'item-description': 'test560091',
          'line-number': 2,
          'line-price': -58.00,
          'line-tax': null,
          'price-per-unit': null,
          quantity: 0,
      },
      {
          item: null,
          'item-description': 'totalpromo',
          'line-number': 3,
          'line-price': -10.000000000000,
          'line-tax': null,
          'price-per-unit': null,
          quantity: 0,
      },
  ],
  'order-date': '05/10/2024',
  'order-number': null,
  'order-status': 'ONHOLD',
  'order-type': 'STANDARD',
  'phone-number': null,
  'po-number': 'PO availability test',
  'ref-number': '111595',
  'ship-to-address': '25 BARKER RD, Stratham, NH, US, 03885',
  'shipping-method': 'Ground',
};

export const bremenRepairTermsAndConditionsLink = 'https://onlinestore.resmed.com/help/20230607_General_Repair_and_Maintenance_TCs_bilingual_Ger_ENG_59204.5.pdf';
export const lyonRepairTermsAndConditionsLink = 'https://onlinestore.resmed.com/help/Final_General_Repair_&_Maintenance_TCs_Consolidated_FR&UK_ver._22.01.2024(75327.2).PDF';

export const DATE_FIELDS = new Set([
  "ordered-date",
  "ordered-date-format",
]);

export const RETURN_CENTER_ADDRESS_KEY = 'returnCenterAddressData';